import {HoistModel, managed, XH} from '@xh/hoist/core';
import {SecuritySubTypeEnum, SecurityTypeEnum} from '../../data/DataTypes';
import {GridModel} from '@xh/hoist/cmp/grid';
import {SecurityGridModel} from './impl/SecurityGridModel';

export type InstrumentSelectedParams = {
    type: SecurityTypeEnum;
    subType: SecuritySubTypeEnum;
};

export class SecMasterTabModel extends HoistModel {
    @managed instrumentTreeModel = this.createInstrumentTree();
    @managed securityGridModel = new SecurityGridModel();

    constructor() {
        super();

        this.addReaction({
            track: () => this.instrumentTreeModel.selectedRecord,
            run: record => {
                let type: SecurityTypeEnum;
                let subType: SecuritySubTypeEnum;

                if (!record?.parent) {
                    type = record?.data.type;
                } else {
                    type = record.parent.data.type;
                    subType = record.data.type;
                }

                this.securityGridModel.setSecurityType({type, subType});
            }
        });
    }

    private createInstrumentTree(): GridModel {
        const gridModel = new GridModel({
            treeMode: true,
            treeStyle: 'none',
            columns: [
                {field: 'id', hidden: true},
                {field: 'type', hidden: true},
                {
                    field: 'label',
                    displayName: 'Asset Type',
                    isTreeColumn: true,
                    sortable: false,
                    flex: 1
                }
            ]
        });

        gridModel.loadData([
            {
                id: XH.genId(),
                type: SecurityTypeEnum.EQUITY,
                label: 'Equities',
                children: [
                    {id: XH.genId(), type: SecuritySubTypeEnum.STOCK, label: 'Stocks'},
                    {id: XH.genId(), type: SecuritySubTypeEnum.ETF, label: 'ETFs'},
                    {id: XH.genId(), type: SecuritySubTypeEnum.INDEX, label: 'Indices'},
                    {id: XH.genId(), type: SecuritySubTypeEnum.ADR, label: 'ADRs'},
                    {id: XH.genId(), type: SecuritySubTypeEnum.OPTIONS, label: 'Options'},
                    {id: XH.genId(), type: SecuritySubTypeEnum.MUTUAL_FUND, label: 'Mutual Funds'}
                ]
            },
            {
                id: XH.genId(),
                type: SecurityTypeEnum.FUTURE,
                label: 'Futures',
                children: [
                    {id: XH.genId(), type: SecuritySubTypeEnum.COMMODITY, label: 'Commodity'},
                    {id: XH.genId(), type: SecuritySubTypeEnum.RATES, label: 'Rate'},
                    {id: XH.genId(), type: SecuritySubTypeEnum.EQUITY, label: 'Equity'}
                ]
            },
            {
                id: XH.genId(),
                type: SecurityTypeEnum.BOND,
                label: 'Bonds',
                children: [
                    {id: XH.genId(), type: SecuritySubTypeEnum.TREASURY, label: 'Treasuries'},
                    {id: XH.genId(), type: SecuritySubTypeEnum.MUNI, label: 'Municipals'},
                    {id: XH.genId(), type: SecuritySubTypeEnum.CORP, label: 'Corporate'},
                    {id: XH.genId(), type: SecuritySubTypeEnum.ANNUITY, label: 'Annuities'}
                ]
            },
            {
                id: XH.genId(),
                type: SecurityTypeEnum.CASH,
                label: 'Cash',
                children: [
                    {id: XH.genId(), type: SecuritySubTypeEnum.CASH, label: 'Cash'},
                    {id: XH.genId(), type: SecuritySubTypeEnum.CD, label: 'CDs'},
                    {id: XH.genId(), type: SecuritySubTypeEnum.MONEY_MARKET, label: 'Money Market'}
                ]
            },
            {
                id: XH.genId(),
                type: SecurityTypeEnum.FX,
                label: 'FX',
                children: [
                    {id: XH.genId(), type: SecuritySubTypeEnum.SPOT, label: 'Spot'},
                    {id: XH.genId(), type: SecuritySubTypeEnum.CRYPTO, label: 'Crypto'}
                ]
            }
        ]);
        return gridModel;
    }
}
